exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".forgot-password {\n  display: flex;\n  justify-content: center; }\n  .forgot-password a {\n    text-decoration: underline; }\n  .forgot-password .login-page-link {\n    margin-right: 8px; }\n\n#portal-login-form .login-input-group {\n  max-width: none; }\n  #portal-login-form .login-input-group .login-input-tag {\n    width: 100%; }\n\n#portal-login-form .login-action-bar {\n  display: flex;\n  justify-content: center;\n  background-color: inherit;\n  text-align: left; }\n  #portal-login-form .login-action-bar .portal-login-btn {\n    margin: 0px; }\n\n#portal-login-form .login-form-button {\n  width: 40%; }\n\n#portal-login-form #login-group-id .ssg-forms-label {\n  font-size: 18px;\n  padding-bottom: 10px; }\n\n#portal-login-form #login-group-id #subElements {\n  margin-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/login/login-form.scss
// module id = 1367
// module chunks = 0